import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import TutorCourseQuizConfigPanel from '../components/tutor/quiz/TutorCourseQuizConfigPanel';

export default function TutorCourseQuizConfigPage() {
  const { courseId } = useParams<{ courseId: string }>();
  const navigate = useNavigate();
  const cId = Number(courseId);

  return (
    <Box sx={{ p: 3, maxWidth: 640 }}>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link component="button" underline="hover" onClick={() => navigate('/tutor/courses')}>
          My Courses
        </Link>
        <Typography color="text.primary">Quiz Configuration</Typography>
      </Breadcrumbs>

      <Typography variant="h5" gutterBottom>Course Quiz Configuration</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Set default quiz settings for all topics in this course. Individual topics can override these settings.
      </Typography>

      <TutorCourseQuizConfigPanel courseId={cId} />
    </Box>
  );
}
